import React, { useEffect, useState } from "react";
import useContactUsService from "../../services/useContactUsService";
import CrudTable from "../../components/dashboard/table/CrudTable";
import DashboardWrapper from "../../components/DashboardWrapper";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import Breadcrumb from "../../components/Breadcrumbdashboard";

export default function ContactUsMessages() {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    "sl",
    "name",
    "email",
    "subject",
    "message",
    "created_at",
  ];

  const fetchContactMessages = async () => {
    try {
      const response = await useContactUsService.getAllCustomersContactUsForm();

      const formattedMessages = response.data.map((item, index) => ({
        sl: index + 1,
        ...item,
        created_at: new Date(item.created_at).toLocaleDateString(),
      }));

      setMessages(formattedMessages);
    } catch (error) {
      console.error("Error fetching contact messages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactMessages();
  }, []);

  const handleEdit = (row) => {
    // Optional: navigate to detail page
    // navigate(`/admin/contact-us/${row.id}`);
  };

  const handleDelete = () => {
    // Optional: delete logic
  };

  return (
    <DashboardWrapper>
      <div className="container-fluid mt-4">
         <div className="d-flex justify-content-between align-items-center mb-1">
         <h4 className="mb-0">Customer Contact Messages</h4>
        <Breadcrumb/>
          {/* <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate("/admin/customer/create")}
          >
            Create Customer
          </button> */}
        </div>

        <div className="card shadow">
          <div className="card-header">
            {/* <h4 className="mb-0">Customer Contact Messages</h4> */}
          </div>

          <div className="card-body">
            {loading ? (
              <Loader />
            ) : (
              <CrudTable
                data={messages}
                columns={columns}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            )}
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
